import React, { useState } from "react";
import { Layout } from "antd";
import { Link } from "react-router-dom";

const SideBar = ({ menu }) => {
  const [collapsed, setCollapsed] = useState(false);
  const Header = () => {
    const onCollapse = () => {
      setCollapsed(!collapsed);
    };

    return (
      <div
        className="relative"
        style={{ backgroundColor: "#ffffff", padding: "16px", borderRadius: "24px 24px 0 0" }}
        onClick={() => onCollapse()}
      >
        <Link className="flex items-center gap-2" to="/app/dashboard">
          <img
            alt="logo"
            src={process.env.PUBLIC_URL + process.env.REACT_APP_COMPANY_LOGO_WITH_NAME_BLACK}
            className=""
          />
          {/* <h1 className="font-montserrat text-gray-900 font-bold text-base overflow-hidden uppercase">
            {process.env.REACT_APP_COMPANY_NAME}
          </h1> */}
        </Link>
        {/* <button className="fixed top-10 left-60" onClick={() => onCollapse()}>
                  {
                      collapsed ? <RightCircleTwoTone /> : <LeftCircleTwoTone />
                  }
              </button> */}
      </div>
    );
  };
  return (
    <Layout.Sider
      className="sidebar rounded-3xl pt-6"
      breakpoint={"lg"}
      theme="light"
      collapsedWidth={0}
      trigger={null}
      width="300px"
      style={{
        overflow: "hidden",
        height: "calc(100vh - 48px)",
        position: "sticky",
        top: "24px",
        left: 0,
        padding: "0",
        backgroundColor: "#ffffff",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="h-full flex flex-col relative">
        <div
          className="sticky top-0 z-10 shrink-0"
          style={{ backgroundColor: "#ffffff" }}
        >
          <Header />
        </div>
        <div
          className="flex min-h-0 flex-1 flex-col overflow-hidden"
          style={{
            padding: "0 16px 16px 16px",
            borderRadius: "0 0 24px 24px",
          }}
        >
          {menu}
        </div>
      </div>
    </Layout.Sider>
  );
};
export default SideBar;